import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import BlockIcon from '@mui/icons-material/Block';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import React from 'react';

import catalogStyles from 'AppRoutes/BeerStore/styles';
import { SemAlcool, SemGluten, LowCarb } from 'assets/icons';
import type { Growler } from 'utils/types/Growler';

interface GrowlerCatalogCardProps {
  growler: Growler;
  onOpen: (id: string) => void;
  onAdd: (growler: Growler) => void;
}

const GrowlerCatalogCard: React.FC<GrowlerCatalogCardProps> = ({
  growler,
  onOpen,
  onAdd,
}) => {
  const hasPriceDiscount =
    typeof growler.originalPrice === 'number' &&
    growler.originalPrice > growler.price;

  return (
    <Card
      sx={{
        ...catalogStyles.productCard,
        bgcolor: '#fff',
        backgroundColor: '#fff',
      }}
      onClick={() => onOpen(growler.id)}
    >
      {(growler.semAlcool || growler.semGluten) && (
        <Box sx={catalogStyles.stampsBadge}>
          {growler.semAlcool && (
            <Box
              component="img"
              src={SemAlcool}
              alt="Sem álcool"
              sx={catalogStyles.stampIcon}
            />
          )}
          {growler.semGluten && (
            <Box
              component="img"
              src={SemGluten}
              alt="Sem glúten"
              sx={catalogStyles.stampIcon}
            />
          )}
        </Box>
      )}

      {(growler.lowCarb || hasPriceDiscount || !growler.inStock) && (
        <Box sx={catalogStyles.stampsBadgeRight}>
          {!growler.inStock && (
            <Box sx={catalogStyles.outOfStockBadgeInColumn}>
              <BlockIcon sx={catalogStyles.outOfStockIcon} />
              <Typography sx={catalogStyles.outOfStockText}>
                ESGOTADO
              </Typography>
            </Box>
          )}
          {growler.lowCarb && (
            <Box
              component="img"
              src={LowCarb}
              alt="Low Carb"
              sx={catalogStyles.stampIcon}
            />
          )}
          {hasPriceDiscount && growler.inStock && growler.originalPrice && (
            <Box sx={catalogStyles.discountBadgeInColumn}>
              <LocalOfferIcon sx={catalogStyles.discountIcon} />
              <Typography variant="caption" sx={catalogStyles.discountText}>
                -
                {Math.round(
                  ((growler.originalPrice - growler.price) /
                    growler.originalPrice) *
                    100,
                )}
                %
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <CardMedia
        component="img"
        image={growler.image}
        alt={growler.name}
        sx={{ ...catalogStyles.productImage, backgroundColor: '#fff' }}
      />

      <CardContent sx={catalogStyles.productContent}>
        <Typography
          variant="h6"
          sx={catalogStyles.productName}
          noWrap
          title={growler.name}
        >
          {growler.name}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={catalogStyles.productBrewery}
        >
          {growler.brewery}
        </Typography>
        <Typography variant="body2" sx={catalogStyles.productStyle}>
          {growler.style} • {growler.abv}% ABV • {growler.volume}ml
        </Typography>
        <Box sx={catalogStyles.priceContainer}>
          {hasPriceDiscount && growler.originalPrice && (
            <Typography variant="body2" sx={catalogStyles.originalPrice}>
              R$ {growler.originalPrice.toFixed(2)}
            </Typography>
          )}
          <Typography variant="h6" sx={catalogStyles.currentPrice}>
            R$ {growler.price.toFixed(2)}
          </Typography>
        </Box>

        {/* Futuro: exibir preço para assinante
        <Box sx={catalogStyles.subscriberSection}>
          <Typography variant="caption">Assinante</Typography>
          <Typography>
            R$ {growler.subscriberPrice?.toFixed(2)}
          </Typography>
        </Box>
        */}

        <Button
          variant="contained"
          fullWidth
          disabled={!growler.inStock}
          startIcon={<AddShoppingCartIcon />}
          onClick={event => {
            event.stopPropagation();
            if (growler.inStock) onAdd(growler);
          }}
          sx={catalogStyles.addToCartButton}
        >
          {growler.inStock ? 'Adicionar' : 'Esgotado'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default GrowlerCatalogCard;
